module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/opony@3x-3e6dfae2.svg";